import styled from "styled-components";

const FOOTER_HEIGHT = 64;

export const JobPageWrapper = styled.div`
  /* Mirror the Run page so the sticky footer never overlaps the last panel. */
  padding-bottom: ${FOOTER_HEIGHT + 8}px;

  .job-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${FOOTER_HEIGHT}px;
    background-color: var(--bg-color-secondary, #ffffff);
    border-top: 1px solid var(--border-color, #e8e8e8);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 32px;
  }
  /* Shrink the delete button to match the Run page's primary-btn size — the
     default .delete-btn style is 16px 42.7px padding with 16px font, which
     looks oversized inside a 64px footer next to the Run page's compact
     6px 24px / 13px Run button. */
  .job-footer .delete-btn {
    padding: 6px 24px;
    font-size: 13px;
  }
`;
